var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { TextInput } from './TextInput';
import { TextArea } from './TextArea';
import { formTextElementStyles, formTextBackgroundStyles, useFormTextStateProps, useTextInputVariantProps, useTextAreaVariantProps, } from './context';
var InlineWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StackedWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var InlineTextWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var $inputWidth = _a.$inputWidth;
    return "\n    display: inline-block;\n    position: relative;\n    width: ".concat($inputWidth || '100%', ";\n    max-width: 500px;\n  ");
});
export var FormTextElementWrapper = function (_a) {
    var formTextElement = _a.formTextElement, formFieldHelper = _a.formFieldHelper, inlineContextualHelp = _a.inlineContextualHelp, characterCounter = _a.characterCounter, inputWidth = _a.inputWidth;
    return (React.createElement(StackedWrapper, null,
        React.createElement(InlineWrapper, null,
            React.createElement(InlineTextWrapper, { "$inputWidth": inputWidth },
                formTextElement,
                characterCounter),
            inlineContextualHelp),
        formFieldHelper));
};
var StyledBaseTextInput = styled(TextInput)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), formTextElementStyles, formTextBackgroundStyles);
var StyledBaseTextArea = styled(TextArea)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), formTextElementStyles, formTextBackgroundStyles, function (_a) {
    var characterCounter = _a.characterCounter;
    return "\n    ".concat((characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.show)
        ? css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            padding-bottom: 25px;\n            scroll-padding-bottom: 25px;\n          "], ["\n            padding-bottom: 25px;\n            scroll-padding-bottom: 25px;\n          "]))) : css(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""]))), "\n  ");
});
export var BaseTextInput = React.forwardRef(function (props, ref) {
    var textInputVariantProps = useTextInputVariantProps(props);
    var formTextStateProps = useFormTextStateProps({});
    var characterCounterWidth = props.characterCounterWidth, characterCounter = props.characterCounter;
    return (React.createElement(StyledBaseTextInput, __assign({ ref: ref, "$paddingRight": (characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.show) && characterCounterWidth
            ? characterCounterWidth
            : 8 }, props, formTextStateProps, textInputVariantProps)));
});
export var BaseTextArea = React.forwardRef(function (props, ref) {
    var textAreaVariantProps = useTextAreaVariantProps(props);
    var formTextStateProps = useFormTextStateProps({});
    return (React.createElement(StyledBaseTextArea, __assign({ ref: ref }, props, formTextStateProps, textAreaVariantProps, (formTextStateProps.$isDisabled ? { resizable: false } : {}))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=BaseFormText.js.map